import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Vehicle } from "src/app/model/vehicle";
import {
  PublicProjectResponse,
  VcuResponse,
  PublicProject,
  Vcu,
  Image,
  GetAllPublicProjectsResponse,
  ToggleFavoriteProject,
  PublicProjectsFeedResponse,
} from "../public-project-response";
import { PublicService } from "../service.service";
import { IMAGE_DEFAULT } from "src/app/model/mockup/image-mockup";
import { Location } from "@angular/common";
import { ConfirmationService, Message, MessageService } from "primeng/api";
import { sharingProjectType } from "src/app/model/enum/sharingProjectType";
import { TranslocoService } from "@ngneat/transloco";
import { enviroment } from "src/environments/environment";
import { IMAGE_SIZES } from "src/app/model/image-sizes";
import { AuthService } from "src/app/service/auth.service";
import { ProjectService } from "src/app/service/project.service";
import { Project } from 'src/app/model/form/project';
import { ProjectSummaryResponse } from "src/app/model/response/ProjectSummaryResponse";
import { PublicProjectDetailsComponent } from "../public-project-details/public-project-details.component";
import { firstValueFrom, map, Subject, takeUntil, tap } from "rxjs";

@Component({
  selector: "app-public-project",
  templateUrl: "./public-project.component.html",
  styleUrl: "./public-project.component.css",
  providers: [PublicProjectDetailsComponent],
})
export class PublicProjectComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  options = ["list", "grid"];
  layout: "list" | "grid" = "list";

  products = signal<any>([]);

  isLoadingProjects: boolean = false;

  publicProjectID = 1;

  pageTitle: string = "";

  selectedTab: "publicProjects" | "favoriteProjects" = "publicProjects";
  currentIndex = 0;
  currentIndexShared = 0;
  showSearch = false;

  vcus: Vcu[];
  project: PublicProject | null;
  publicEquipaments: string[] = [];
  publicDetails: string[] = [];
  responsiveOptions: any[] | undefined;
  vehicle = new Vehicle();
  vcu: Vcu | undefined;
  idAux: number = 0;
  dataProject: PublicProjectResponse | undefined;
  publicUser: string = "";
  publicProject: string = "";
  publicLanguage: string = "";

  message: Message[];

  userLogged: string;

  filterValue: string = "";

  showDetailsModal: boolean = false;
  showUnloggedUserModal: boolean = false;

  allLoadedItems: GetAllPublicProjectsResponse[] = [];
  selectedFavoriteProjectIDs: string[] = [];

  pbPrimaryImage: string | null = null;
  imageStyle: any;

  nextCursor: string | null = null;
  hasMore: boolean = true;
  isLoadingMore: boolean = false;

  @ViewChild('scrollSentinel') sentinelRef?: ElementRef;

  filterOptions = [
    { name: "Todos", value: "all" },
    { name: "Favoritos", value: "favorites" },
    { name: "Mais Curtidos", value: "likes" },
  ];
  selectedFilter: string = "all"; // Filtro padrão

  constructor(
    private publicService: PublicService,
    private route: ActivatedRoute,
    private location: Location,
    private confirmationService: ConfirmationService,
    private router: Router,
    private messageService: MessageService,
    private translocoService: TranslocoService,
    private authService: AuthService,
    private projectService: ProjectService,
    private publicProjectDetails: PublicProjectDetailsComponent,
    private titleService: Title
  ) {
    this.userLogged = this.authService.getUserInformations();
    this.project = null;
    this.vcus = [];
    this.message = [];
    this.isLoadingProjects = true;

    this.route.params.subscribe((params) => {
      this.publicUser = params["user"];
      this.publicProject = params["project"];
    });

    this.getSelectedFavoriteProjectList(1, 5, () => {
      if (this.route.routeConfig?.path == "public-projects") {
        this.getAllPublicProjects();
      } else if (this.route.routeConfig?.path == "favorite-projects") {
        this.getFavoriteProjects(1, 50);
      } else {
        this.getPublicLinkProject(this.publicProject);
      }
    });
  }

  ngOnInit(): void {
    this.setTitle();
    this.getLocation();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setTitle() {
    const titleKey =
      this.route.routeConfig?.path === "favorite-projects"
        ? "title.favorite-projects"
        : "title.public-projects";
    this.translocoService
      .selectTranslate(titleKey)
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.titleService.setTitle(value));
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.checkSentinel();
  }

  private checkSentinel(): void {
    if (this.selectedTab !== 'publicProjects') return;
    if (this.isLoadingMore || !this.hasMore) return;
    if (!this.sentinelRef?.nativeElement) return;
    const rect = this.sentinelRef.nativeElement.getBoundingClientRect();
    if (rect.top <= window.innerHeight + 300) {
      this.loadMore();
    }
  }

  loadMore(): void {
    if (this.isLoadingMore || !this.hasMore) return;
    this.isLoadingMore = true;
    this.getAllPublicProjects();
  }

  //#region Projeto Público com Link
  getPublicLinkProject(projectID: string) {
    this.publicService.getPublicLinkProject(projectID).subscribe({
      next: (data) => {
        this.allLoadedItems = data.listItens ?? [];
        this.filterProjects({ name: "Todos", value: "all" });
        this.isLoadingProjects = false;
      },
      error: (error) => {
        console.error("Error fetching public link project:", error);
        this.isLoadingProjects = false;
        this.messageService.add({
          key: "toastAccount",
          severity: "error",
          summary: this.translocoService.translate('messages.error.fetchPublicError'),
        });
      },
    });
  }
  //#endregion

  //#region Projeto Público listado
  getAllPublicProjects() {
    this.publicService
      .getAllPublicProjects(sharingProjectType.PUBLIC, this.nextCursor)
      .subscribe({
        next: (data) => {
          this.allLoadedItems = [...this.allLoadedItems, ...data.listItens];
          this.nextCursor = data.nextCursor;
          this.hasMore = data.nextCursor !== null;
          this.filterProjects({ name: 'Todos', value: this.selectedFilter });
          this.isLoadingProjects = false;
          this.isLoadingMore = false;
          // Se o sentinel ainda estiver visível após o render, carrega o próximo lote
          setTimeout(() => this.checkSentinel(), 150);
        },
        error: (error) => {
          console.error("Error fetching all public projects:", error);
          this.isLoadingProjects = false;
          this.isLoadingMore = false;
          this.messageService.add({
            key: "toastAccount",
            severity: "error",
            summary: this.translocoService.translate('messages.error.fetchAllProjectsError'),
          });
        },
      });
  }
  //#endregion

  //#region Projetos Favoritados
  getFavoriteProjects(page: number, itensPage: number) {
    if (this.userLogged) {
      this.publicService
        .getFavoriteProject(this.userLogged, page, itensPage)
        .subscribe({
          next: (data) => {
            this.allLoadedItems = data.listItens ?? [];
            this.filterProjects({ name: "Todos", value: "all" });
            this.isLoadingProjects = false;
          },
          error: (error) => {
            console.error("Error fetching favorite projects:", error);
            this.isLoadingProjects = false;
            this.messageService.add({
              key: "toastAccount",
              severity: "error",
              summary: this.translocoService.translate('messages.error.fetchFavoritesError'),
            });
          },
        });
    } else {
      setTimeout(() => {
        this.isLoadingProjects = false;
      }, 2500);
    }
  }

  //#endregion

  toggleFavoriteProject(projectID: string) {
    if (this.userLogged) {
      const updatedProjects = this.products().map((project: any) => {
        if (project.projectID === projectID) {
          project.isFavorite = !project.isFavorite;

          if (project.isFavorite) {
            project.likes += 1;
            this.selectedFavoriteProjectIDs.push(projectID);
          } else {
            this.selectedFavoriteProjectIDs =
              this.selectedFavoriteProjectIDs.filter((id) => id !== projectID);
            project.likes -= 1;
          }
        }
        return project;
      });
      this.products.set(updatedProjects);

      this.publicService
        .toggleFavoriteProject(projectID, this.userLogged)
        .subscribe(
          (data) => {
            Object.values(data).map((response) => {
              if (response === "successAdd") {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastAccount",
                  severity: "success",
                  summary: this.translocoService.translate(
                    "publicProject.toggleFavoriteProject.successMessageAdd"
                  ),
                });
              } else if (response === "successRemove") {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastAccount",
                  severity: "success",
                  summary: this.translocoService.translate(
                    "publicProject.toggleFavoriteProject.successMessageRemove"
                  ),
                });
              }
            });
          },
          (error) => {
            const revertedProjects = this.products().map((project: any) => {
              if (project.projectID === projectID) {
                project.isFavorite = !project.isFavorite;

                if (project.isFavorite) {
                  this.selectedFavoriteProjectIDs.push(projectID);
                } else {
                  this.selectedFavoriteProjectIDs =
                    this.selectedFavoriteProjectIDs.filter(
                      (id) => id !== projectID
                    );
                }
              }
              return project;
            });
            this.products.set(revertedProjects);
          }
        );
    } else {
      this.showUnloggedUserModal = true;
    }
  }

  getSelectedFavoriteProjectList(
    page: number,
    itensPage: number,
    callback?: () => void
  ) {
    if (this.userLogged) {
      this.publicService
        .getSelectedFavoriteProjectList(this.userLogged)
        .subscribe({
          next: (data) => {
            this.selectedFavoriteProjectIDs = Object.values(data).map(
              (project) => project.projectID
            );
            if (callback) callback();
          },
          error: (error) => {
            console.error("Error fetching favorite projects:", error);
            this.messageService.add({
              key: "toastAccount",
              severity: "error",
              summary: this.translocoService.translate('messages.error.fetchFavoritesError'),
            });
            if (callback) callback();
          },
        });
    } else {
      setTimeout(() => {
        this.isLoadingProjects = false;
        if (callback) callback();
      }, 2500);
    }
  }
  //#endregion

  getLocation() {
    let lang = sessionStorage.getItem("language");
    this.publicService.getCountry().subscribe((data: any) => {
      this.publicLanguage = data.country_code;
      if (!lang) {
        switch (data.country_code) {
          case "BR":
            lang = "pt-br";
            break;

          default:
            lang = "en-us";
            break;
        }
      }
    });
  }

  getProject(userID: string, projectID: string) {
    this.publicEquipaments = [];
    this.publicDetails = [];
    this.isLoadingProjects = true;

    if (!this.userLogged) {
      this.isLoadingProjects = false;
      this.showUnloggedUserModal = true;
      return;
    }

    this.publicService.getPublicProject(userID, projectID).subscribe({
      next: (data) => {
        this.dataProject = data;

        if (!this.dataProject) {
          this.isLoadingProjects = false;
          this.messageService.add({
            key: "toastAccount",
            severity: "warn",
            summary: this.translocoService.translate('messages.error.projectNotExist'),
          });
          return;
        }

        if (
          this.dataProject.attributes &&
          this.dataProject.attributes.photo &&
          this.dataProject.attributes.primaryImage
        ) {
          const photoArray = this.dataProject.attributes.photo.split(",");
          const primaryIndex = photoArray.indexOf(
            this.dataProject.attributes.primaryImage
          );

          if (primaryIndex !== -1) {
            photoArray.splice(primaryIndex, 1);
            photoArray.unshift(this.dataProject.attributes.primaryImage);
          }

          this.dataProject.attributes.photo = photoArray.join(",");
        }

        this.project = this.toPublicProject(this.dataProject);

        this.vcus = this.project?.vcus ?? [];
        this.publicEquipaments = [
          ...this.vcus
            .map((vcu) => vcu.model)
            .filter((model): model is string => model !== null),
          ...(this.dataProject.equipments || []),
        ];

        this.setImageDefault();

        this.responsiveOptions = [
          { breakpoint: "1430px", numVisible: 3, numScroll: 1 },
          { breakpoint: "1260px", numVisible: 2, numScroll: 1 },
          { breakpoint: "870px", numVisible: 1, numScroll: 1 },
        ];

        window.scrollTo({ top: 0, behavior: "smooth" });
        this.isLoadingProjects = false;
        this.showDetailsModal = true;
      },
      error: (error) => {
        console.error("Erro ao encontrar o projeto:", error);
        this.isLoadingProjects = false;
        this.messageService.add({
          key: "toastAccount",
          severity: "error",
          summary: this.translocoService.translate('messages.error.findProjectError'),
        });
      },
    });
  }

  setImageDefault() {
    if (this.project && this.project.images.length < 5) {
      for (let i = this.project.images.length; i < 5; i++) {
        this.project.images.push(IMAGE_DEFAULT);
      }
    }
  }

  toPublicProject(projectResponse: PublicProjectResponse): PublicProject {
    return new PublicProject(
      projectResponse.projectName,
      new Vehicle(
        0,
        projectResponse.attributes?.manufacturer,
        projectResponse.attributes?.["vehicle-model"],
        projectResponse.attributes?.["date-of-manufacture"]
          ? new Date(projectResponse.attributes?.["date-of-manufacture"])
          : null
      ),
      this.vcuResponseToVcu(projectResponse.vcus),
      projectResponse.equipments,
      this.stringToImage(projectResponse.attributes?.photo, "photo"),
      null,
      null
    );
  }

  publicStringToImage(
    path: string,
    str: string | null,
    typeFile: string
  ): Image[] {
    if (!path) return [];
    const [userID, projectID] = path.split("|");
    if (!str || str === "") return [];
    const { w, h } = IMAGE_SIZES.gallery;
    const base = `${enviroment.BASE_URL_CDN_MEDIA}fit-in/${w}x${h}/${userID}/${projectID}/${typeFile}`;
    return str.split(",").map((name, index) =>
      new Image(index, name.trim(), `${base}/${name.trim()}`)
    );
  }

  stringToImage(str: string | null, typeFile: string): Image[] {
    const path = this.dataProject?.path;
    if (!path) return [];
    const [userID, projectID] = path.split("|");
    if (!str || str === "") return [];
    const { w, h } = IMAGE_SIZES.gallery;
    const base = `${enviroment.BASE_URL_CDN_MEDIA}fit-in/${w}x${h}/${userID}/${projectID}/${typeFile}`;
    return str.split(",").map((name, index) =>
      new Image(index, name.trim(), `${base}/${name.trim()}`)
    );
  }

  vcuResponseToVcu(vcusResp: VcuResponse[]): Vcu[] {
    if (!vcusResp) return [];

    let vcus: Vcu[] = [];
    vcusResp.map((vcu) => vcus.push(this.toVcu(vcu)));
    return vcus;
  }

  toVcu(vcu: VcuResponse): Vcu {
    if (vcu) {
      return new Vcu(vcu.nickname, vcu.model);
    }
    return new Vcu();
  }

  backPage() {
    this.router.navigate(["/"]);
  }

  closeDetailModal() {
    this.showDetailsModal = false;
  }
  closeUnloggedUserModal() {
    this.showUnloggedUserModal = false;
  }

  goToPage(page: string) {
    this.router.navigate([page]);
  }

  applyFilter() {
    const filter = this.filterValue.trim().toLowerCase();
    const allProjects = this.allLoadedItems.map((item: any) =>
      this.toProjectSummary(item)
    );

    const filteredProjects = allProjects.filter(
      (project: ProjectSummaryResponse) =>
        project.projectName.toLowerCase().includes(filter) ||
        project.attributes?.manufacturer?.toLowerCase().includes(filter)
    );

    this.products.set(filter === "" ? allProjects : filteredProjects);
  }

  filterProjects(filter: any) {
    this.selectedFilter = filter.value;
    const allProjects = this.allLoadedItems.map(
      (project: GetAllPublicProjectsResponse) => this.toProjectSummary(project)
    );

    if (filter.value === "all") {
      this.products.set(allProjects);
    } else if (filter.value === "favorites") {
      this.products.set(allProjects.filter((project) => project.isFavorite));
    } else if (filter.value === "likes") {
      this.products.set([...allProjects].sort((a, b) => b.likes - a.likes));
    }
  }

  toAllPublicProjects(
    publicProjectResponse: GetAllPublicProjectsResponse
  ): Project {
    const attributes = publicProjectResponse.attributes ?? null;

    const vehicle = attributes
      ? new Vehicle(
          0,
          attributes.manufacturer ?? "",
          attributes["vehicle-model"] ?? "",
          attributes["date-of-manufacture"]
            ? new Date(attributes["date-of-manufacture"])
            : null
        )
      : null;

    const images = this.stringToImage(attributes?.photo, "photo");
    const primaryImage =
      images.find((img) => img.name === attributes?.primaryImage) ?? null;

    return new Project(
      publicProjectResponse.projectID, // id
      false, // favorite
      publicProjectResponse.projectName, // name
      null, // status
      [], // application
      vehicle, // vehicle
      [], // tags
      attributes?.detail ?? "", // detail
      [], // vcus
      [], // equipments
      primaryImage ? [new Image(0, attributes?.primaryImage)] : [],
      attributes?.primaryImage ? new Image(0, attributes?.primaryImage) : null, // primaryImage
      null, // sharedBy
      [], // sharedWith
      [], // maps
      [], // logs
      "", // instagram
      attributes, // attributes
      publicProjectResponse.userID, // userID
      "", // ownerUser
      false, // isSharing
      null, // sharingProjectType
      publicProjectResponse.likes // likes
    );
  }

  toProjectSummary(
    project: GetAllPublicProjectsResponse
  ): ProjectSummaryResponse {
    var isFavorite = this.selectedFavoriteProjectIDs.includes(
      project.projectID
    );
    return new ProjectSummaryResponse(
      project.projectID, // projectID
      project.projectName, // projectName
      false, // default (valor padrão, ajustar se necessário)
      project.primaryImage?.[0]?.name ?? "", // primaryImage (assumindo que é o nome da imagem principal)
      project.userID, // sharedBy
      [], // tags (ajustar se vier de outro campo)
      [project.nickname], // nickname (transformado em array)
      project.attributes ?? undefined, // attributes
      project.userID ?? "", // ownerUser
      project.likes ?? 0, // likes
      [], // application (ajustar se necessário)
      "", // ownerUserName (ajustar se disponível)
      isFavorite
    );
  }


  selectTab(tab: "publicProjects" | "favoriteProjects") {
    this.currentIndex = 0;
    this.currentIndexShared = 0;
    this.selectedTab = tab;
    this.isLoadingProjects = true;
    this.allLoadedItems = [];
    this.nextCursor = null;
    this.hasMore = true;

    if (tab === "publicProjects") {
      this.getAllPublicProjects();
    } else {
      this.getFavoriteProjects(1, 50);
    }
  }


  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  goToPageProject(userID: string, projectID: string, projectName: string) {
    if (!this.userLogged) {
      this.showUnloggedUserModal = true;
      return;
    } else {
      this.router.navigate([`/project/public/${projectName}`], {
        state: { userID, projectID },
      });
    }
  }
}
